import lod_ from "lodash";
import {
	Card,
	CircularProgress,
	Divider,
	Icon,
	IconButton,
	Tab,
	Tabs,
	Tooltip
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import ConversationTab from "./Tabs/ConversationTab";
import AnalyzeTab from "./Tabs/AnalyzeTab";
import CustomerTab from "./Tabs/CustomerTab";

const PhoneCall = ({
	phoneCall,
	visualiseConversationLoading,
	closePannel,
	fullScreen,
	setFullScreen,
	tab,
	setTab,
	resource
}) => {
	const isConversationAnalysed =
		!lod_.isNil(phoneCall?.analyse) && !lod_.isEmpty(phoneCall?.analyse);
	const version = phoneCall?.version || "2.0";

	return (
		<MDBox
			className="rightPannel"
			sx={{ ml: fullScreen ? 0 : 2 }}
			style={{
				width: fullScreen ? "100%" : "30vw"
			}}
		>
			<Card sx={{ p: 2, height: "100%" }}>
				{visualiseConversationLoading ? (
					<MDBox
						style={{
							height: "100%"
						}}
						display="flex"
						alignItems="center"
						justifyContent="center"
					>
						<CircularProgress color="info" size={60} />
					</MDBox>
				) : (
					<>
						<MDBox display="flex" alignItems="center" justifyContent="space-between">
							<MDBox display="flex" justifyContent="start" flexDirection="column">
								<MDTypography variant="h6">Conversation</MDTypography>
								<MDTypography variant="body2" fontSize="small">
									{phoneCall.fID}
								</MDTypography>
							</MDBox>
							<MDBox display="flex">
								{/* FullScreen */}
								{!fullScreen && (
									<Tooltip placement="top" title="Plein écran">
										<IconButton onClick={() => setFullScreen(!fullScreen)}>
											<Icon>fullscreen</Icon>
										</IconButton>
									</Tooltip>
								)}
								{fullScreen && (
									<Tooltip placement="top" title="Plein écran">
										<IconButton onClick={() => setFullScreen(!fullScreen)}>
											<Icon>fullscreen_exit</Icon>
										</IconButton>
									</Tooltip>
								)}
								{/* Close */}
								<Tooltip placement="top" title="Fermer">
									<IconButton onClick={closePannel}>
										<Icon>close</Icon>
									</IconButton>
								</Tooltip>
							</MDBox>
						</MDBox>
						{!fullScreen && (
							<MDBox>
								<Tabs
									value={tab}
									onChange={(e, v) => {
										setTab(v);
									}}
									aria-label="basic tabs example"
								>
									<MDBox flex="1" onClick={() => setTab(0)}>
										<Tab style={{ width: "100%" }} label="Conversation" />
									</MDBox>
									<Tooltip
										title={!isConversationAnalysed ? "Vous devez d'abord analyser l'appel" : ""}
										placement="top"
									>
										<MDBox flex="1" onClick={() => (isConversationAnalysed ? setTab(1) : {})}>
											<Tab
												style={{ width: "100%" }}
												label="Client"
												disabled={!isConversationAnalysed}
											/>
										</MDBox>
									</Tooltip>
									<Tooltip
										title={!isConversationAnalysed ? "Vous devez d'abord analyser l'appel" : ""}
										placement="top"
									>
										<MDBox flex="1" onClick={() => (isConversationAnalysed ? setTab(2) : {})}>
											<Tab
												style={{ width: "100%" }}
												label="Analyse"
												disabled={!isConversationAnalysed}
											/>
										</MDBox>
									</Tooltip>
								</Tabs>
							</MDBox>
						)}
						{/* If w're not in fullscreen => Use tabs */}
						{!fullScreen && (
							<>
								{/* Conversation */}
								{tab === 0 && <ConversationTab phoneCall={phoneCall} resource={resource} />}
								{/* Customer */}
								{tab === 1 && isConversationAnalysed && (
									<CustomerTab phoneCall={phoneCall} resource={resource} />
								)}
								{/* Analyse */}
								{tab === 2 && isConversationAnalysed && (
									<AnalyzeTab phoneCall={phoneCall} resource={resource} />
								)}
							</>
						)}
						{fullScreen && (
							<MDBox
								display="flex"
								style={{
									height: "100%"
								}}
							>
								<MDBox
									flex={1}
									mr={1}
									style={{
										height: "90%",
										overflowY: "auto"
									}}
								>
									<ConversationTab phoneCall={phoneCall} resource={resource} />
								</MDBox>
								<Divider orientation="vertical" />
								<MDBox
									mr={1}
									ml={1}
									flex={1}
									style={{
										height: "90%",
										overflowY: "auto"
									}}
								>
									<CustomerTab phoneCall={phoneCall} resource={resource} />
								</MDBox>
								<Divider orientation="vertical" />
								<MDBox
									ml={1}
									flex={1}
									style={{
										height: "90%",
										overflowY: "auto"
									}}
								>
									<AnalyzeTab phoneCall={phoneCall} resource={resource} />
								</MDBox>
							</MDBox>
						)}
					</>
				)}
			</Card>
		</MDBox>
	);
};

export default PhoneCall;
